<template>
  <div>
    <b-table small outlined :items="resultats" :fields="fields_course_cumul" sort-by="classement" responsive id="table_equipe" thead-class="head_equipes">
      <template slot="clt" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0; margin-left: 10px">Clt : {{ data.item.clt }}</p>
      </template>
      <!-- TEMPLATE ROW NOM -->
      <template slot="club" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">Equipe : {{ data.item.club }}</p>
      </template>
      <template slot="temps" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">Temps : {{ data.item.temps }}</p>
      </template>
      <template slot="clt_cat" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">Clt Cat : {{ data.item.clt_cat }} {{ data.item.categorie }}</p>
      </template>
      <template slot="clt_sex" slot-scope="data">
        <p style="white-space: nowrap; margin-bottom: 0">Clt Sexe : {{ data.item.clt_sexe }} {{ data.item.sexe }}</p>
      </template>
      <template #row-details="row">
        <b-card class="inner_equipe_classement">
          <b-table small outlined :items="row.item.intermediaire" :fields="fields_course_cumul_inter" responsive tbody-tr-class="row_coureur_equipe" class="table_coureur_equipe">
            <template slot="nom" slot-scope="data">
              <p style="white-space: nowrap; margin: 0 auto; max-width: 200px; width: 200px">{{ data.item.nom }} {{ data.item.prenom }}</p>
            </template>
            <template slot="clt_cat" slot-scope="data">
              <p style="white-space: nowrap; margin-bottom: 0">{{ data.item.clt_cat }} {{ data.item.categorie }}</p>
            </template>
            <template slot="clt_sexe" slot-scope="data">
              <p style="white-space: nowrap; margin-bottom: 0">{{ data.item.clt_sexe }} {{ data.item.sexe }}</p>
            </template>
            <template slot="temps" slot-scope="data">
              <p style="white-space: nowrap; margin-bottom: 0">
                <span class="temps_tab">{{ data.item.temps }}</span>
              </p>
            </template>
          </b-table>
        </b-card>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields_course_cumul: [
        { key: "clt", label: "Clt", sortable: false, tdClass: "" },
        { key: "club", label: "Club", sortable: false, tdClass: "" },
        { key: "temps", label: "Temps", sortable: false, tdClass: "" },

        {
          key: "clt_sex",
          label: "Clt Sexe",
          sortable: false,
          tdClass: "",
        },

        { key: "Club", label: "Club", sortable: false, tdClass: "" },
      ],
      fields_course_cumul_inter: [
        { key: "name", label: "Intermédiaire", sortable: false, tdClass: "" },
        { key: "nom", label: "Nom - Prénom", sortable: false, tdClass: "" },

        { key: "temps", label: "Temps", sortable: false, tdClass: "" },
        { key: "clt", label: "Clt", sortable: false, tdClass: "" },
        { key: "clt_cat", label: "Clt Cat", sortable: false, tdClass: "" },
        {
          key: "clt_sexe",
          label: "Clt Sexe",
          sortable: false,
          tdClass: "",
        },
      ],
    };
  },
  computed: {
    resultats() {
      return this.$store.state.event.data.resultats;
    },
  }
};
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/component/Epreuve/TableauResultatsCourseCumulEquipe.vue